<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
    
    <div style="overflow-x: auto;">
      <table>
        <thead>
          <tr>
            <th>Processo SEI</th>
            <th>Conselho</th>
            <th>Órgão</th> 
            <th>Tipo de Movimentação</th>            
            <th>Indicado</th>
            <th>Destituído</th>
            
            <!-- 1. Envio p/ assinatura -->
            <th class="th-filtro" @mouseleave="dropdownAberto = ''">
              <div class="header-filtro" @click="dropdownAberto = dropdownAberto === 'envio_assinatura' ? '' : 'envio_assinatura'">
                Envio - Assinatura Governador
                <span class="setinha" :class="{ 'aberta': dropdownAberto === 'envio_assinatura' }">&#x25B6;&#xFE0E;</span>
              </div>
              <div class="caixa-filtro-excel" v-if="dropdownAberto === 'envio_assinatura'">
                <ul>
                  <li @click="aplicarOrdenacao('envio_para_assinatura', 'desc')" :class="{ ativo: ordenacaoAtual.coluna === 'envio_para_assinatura' && ordenacaoAtual.ordem === 'desc' }">Mais recentes</li>
                  <li @click="aplicarOrdenacao('envio_para_assinatura', 'asc')" :class="{ ativo: ordenacaoAtual.coluna === 'envio_para_assinatura' && ordenacaoAtual.ordem === 'asc' }">Mais antigos</li>
                </ul>
              </div>
            </th>

            <!-- 2. Retorno do ato assinatura -->
            <th class="th-filtro" @mouseleave="dropdownAberto = ''">
              <div class="header-filtro" @click="dropdownAberto = dropdownAberto === 'retorno_assinatura' ? '' : 'retorno_assinatura'">
                Assinatura Governador 
                <span class="setinha" :class="{ 'aberta': dropdownAberto === 'retorno_assinatura' }">&#x25B6;&#xFE0E;</span>
              </div>
              <div class="caixa-filtro-excel" v-if="dropdownAberto === 'retorno_assinatura'">
                <ul>
                  <li @click="aplicarOrdenacao('data_da_assinatura', 'desc')" :class="{ ativo: ordenacaoAtual.coluna === 'data_da_assinatura' && ordenacaoAtual.ordem === 'desc' }">Mais recentes</li>
                  <li @click="aplicarOrdenacao('data_da_assinatura', 'asc')" :class="{ ativo: ordenacaoAtual.coluna === 'data_da_assinatura' && ordenacaoAtual.ordem === 'asc' }">Mais antigos</li>
                </ul>
              </div>
            </th>            
            
            <!-- 3. Data da entrega do ato p DIEEG -->
            <th class="th-filtro" @mouseleave="dropdownAberto = ''">
              <div class="header-filtro" @click="dropdownAberto = dropdownAberto === 'entrega_dieeg' ? '' : 'entrega_dieeg'">
                Data de Envio p/ DIEEG
                <span class="setinha" :class="{ 'aberta': dropdownAberto === 'entrega_dieeg' }">&#x25B6;&#xFE0E;</span>
              </div>
              <div class="caixa-filtro-excel" v-if="dropdownAberto === 'entrega_dieeg'">
                <ul>
                  <li @click="aplicarOrdenacao('envio_para_dieeg', 'desc')" :class="{ ativo: ordenacaoAtual.coluna === 'envio_para_dieeg' && ordenacaoAtual.ordem === 'desc' }">Mais recentes</li>
                  <li @click="aplicarOrdenacao('envio_para_dieeg', 'asc')" :class="{ ativo: ordenacaoAtual.coluna === 'envio_para_dieeg' && ordenacaoAtual.ordem === 'asc' }">Mais antigos</li>
                </ul>
              </div>
            </th>

            <!-- 4. Envio para validação -->
            <th class="th-filtro" @mouseleave="dropdownAberto = ''">
              <div class="header-filtro" @click="dropdownAberto = dropdownAberto === 'envio_validacao' ? '' : 'envio_validacao'">
                Envio para validação 
                <span class="setinha" :class="{ 'aberta': dropdownAberto === 'envio_validacao' }">&#x25B6;&#xFE0E;</span>
              </div>
              <div class="caixa-filtro-excel" v-if="dropdownAberto === 'envio_validacao'">
                <ul>
                  <li @click="aplicarOrdenacao('envio_para_validacao', 'desc')" :class="{ ativo: ordenacaoAtual.coluna === 'envio_para_validacao' && ordenacaoAtual.ordem === 'desc' }">Mais recentes</li>
                  <li @click="aplicarOrdenacao('envio_para_validacao', 'asc')" :class="{ ativo: ordenacaoAtual.coluna === 'envio_para_validacao' && ordenacaoAtual.ordem === 'asc' }">Mais antigos</li>
                </ul>
              </div>
            </th>

            <!-- 5. Retorno da validação -->
            <th class="th-filtro" @mouseleave="dropdownAberto = ''">
              <div class="header-filtro" @click="dropdownAberto = dropdownAberto === 'retorno_validacao' ? '' : 'retorno_validacao'">
                Retorno da validação 
                <span class="setinha" :class="{ 'aberta': dropdownAberto === 'retorno_validacao' }">&#x25B6;&#xFE0E;</span>
              </div>
              <div class="caixa-filtro-excel" v-if="dropdownAberto === 'retorno_validacao'">
                <ul>
                  <li @click="aplicarOrdenacao('retorno_validacao', 'desc')" :class="{ ativo: ordenacaoAtual.coluna === 'retorno_validacao' && ordenacaoAtual.ordem === 'desc' }">Mais recentes</li>
                  <li @click="aplicarOrdenacao('retorno_validacao', 'asc')" :class="{ ativo: ordenacaoAtual.coluna === 'retorno_validacao' && ordenacaoAtual.ordem === 'asc' }">Mais antigos</li>
                </ul>
              </div>
            </th>            
            
            <!-- 6. Envio p entidade -->
            <th class="th-filtro" @mouseleave="dropdownAberto = ''">
              <div class="header-filtro" @click="dropdownAberto = dropdownAberto === 'envio_entidade' ? '' : 'envio_entidade'">
                Envio p/ entidade 
                <span class="setinha" :class="{ 'aberta': dropdownAberto === 'envio_entidade' }">&#x25B6;&#xFE0E;</span>
              </div>
              <div class="caixa-filtro-excel" v-if="dropdownAberto === 'envio_entidade'">
                <ul>
                  <li @click="aplicarOrdenacao('encaminhamento_entidade', 'desc')" :class="{ ativo: ordenacaoAtual.coluna === 'encaminhamento_entidade' && ordenacaoAtual.ordem === 'desc' }">Mais recentes</li>
                  <li @click="aplicarOrdenacao('encaminhamento_entidade', 'asc')" :class="{ ativo: ordenacaoAtual.coluna === 'encaminhamento_entidade' && ordenacaoAtual.ordem === 'asc' }">Mais antigos</li>
                </ul>
              </div>
            </th>

            <th class="th-observacao">Obs.</th>
          </tr>
        </thead>
        <tbody>
          <!-- O v-for itera sobre acompanhamentosOrdenados para respeitar a ordenação -->
          <template v-for="(acompanhamento, index) in acompanhamentosOrdenados">
            <template>
              <tr 
                :key="acompanhamento.id" 
                :class="[classesDeEstilo[index], 'linha-clicavel']"
                @click="abrirVisualizacao(acompanhamento)"
              >
                <td data-label="Processo SEI:" class="texto-centro">
                  <span>{{ acompanhamento.processo_sei }}</span>
                </td>
                <td data-label="Conselho:" class="texto-centro">                                    
                  <span>{{ formatarNomeProprio(exibirConselho(acompanhamento)) }}</span>
                </td>              
                <td data-label="Órgão / Colegiado:" class="texto-centro">                  
                  <span>{{ formatarNomeProprio(acompanhamento.colegiado_nome) }}</span>
                </td>
                <td data-label="Movimentação:" class="texto-centro">                  
                  <span>{{ formatarTipoMovimentacao(acompanhamento.tipo_movimentacao) }}</span>
                </td>               
                <td data-label="Indicado:" class="texto-centro">
                  <span v-if="acompanhamento.nome_indicado">                    
                    {{ formatarNomeProprio(acompanhamento.nome_indicado) }} <br>
                    <small class="texto-cinza">{{ formatarCPF(acompanhamento.cpf_indicado) }}</small>
                  </span>
                  <span v-else>-</span>
                </td>
                <td data-label="Destituído:" class="texto-centro">
                  <span v-if="acompanhamento.nome_destituido">                    
                    {{ formatarNomeProprio(acompanhamento.nome_destituido) }} <br>
                    <small class="texto-cinza">{{ formatarCPF(acompanhamento.cpf_destituido) }}</small>
                  </span>
                  <span v-else>-</span>
                </td>
                
                <td data-label="Envio p/ assinatura:" style="text-align: center;">
                  <span>{{ formatarData(acompanhamento.envio_para_assinatura) }}</span>
                </td>
                <td data-label="Retorno do ato assinatura:" style="text-align: center;">
                  <span>{{ formatarData(acompanhamento.data_da_assinatura) }}</span>
                </td>                
                <td data-label="Data da entrega do ato p/ DIEEG:" style="text-align: center;">
                  <span>{{ formatarData(acompanhamento.envio_para_dieeg) }}</span>
                </td>
                <td data-label="Envio para validação:" style="text-align: center;">
                  <span>{{ formatarData(acompanhamento.envio_para_validacao) }}</span>
                </td>
                <td data-label="Retorno da validação:" style="text-align: center;">
                  <span>{{ formatarData(acompanhamento.retorno_validacao) }}</span>
                </td>                
                <td data-label="Envio p/ entidade:" style="text-align: center;">
                  <span>{{ formatarData(acompanhamento.encaminhamento_entidade) }}</span>
                </td>

                <!-- COLUNA DA OBSERVAÇÃO -->
                <td class="td-observacao" @click.stop>
                  <span
                    v-if="acompanhamento.obs_acompanhamento"
                    class="icone-tabela icone-observacao"
                    :title="linhasObservacaoAbertas[acompanhamento.id] ? 'Ocultar observação' : 'Exibir observação'"
                    @click="toggleObservacao(acompanhamento.id)">
                    
                    <span v-if="linhasObservacaoAbertas[acompanhamento.id]">&#x25BC;&#xFE0E;</span>
                    <span v-else>&#x25B6;&#xFE0E;</span>
                  </span>
                </td>

              </tr>
              <tr v-if="linhasObservacaoAbertas[acompanhamento.id]" :key="`obs-${acompanhamento.id}`" class="linha-observacao">
                <td colspan="14">
                  <div class="conteudo-observacao">
                    <b>Observações:</b>
                    <span>{{ acompanhamento.obs_acompanhamento }}</span>
                  </div>
                </td>
              </tr>
            </template>
          </template>

          <tr v-if="!acompanhamentosOrdenados || acompanhamentosOrdenados.length === 0" class="sem-resultados">
            <td colspan="14"><p><b>Nenhum Resultado Encontrado</b></p></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { parseISO, format } from "date-fns";
  import MsgErroFormularios from "../MsgErroFormularios";
  import AcompanhamentoApi from "../../services/AcompanhamentoApi";

  export default {
    name: "TabelaResultadosAcompanhamento",
    props: {
      acompanhamentos: Array,
      acompanhamento: Object, 
      permissoes: {
        type: Object,
        default: () => ({ pode_editar: true, pode_deletar: true })
      },
    },
    components: {
      MsgErroFormularios,
    },
    created() {
      this.acompanhamentoApi = new AcompanhamentoApi();
    },
    data() {
      return {
        msgErros: {
          acompanhamento: "",
        },
        erro: false,
        linhasObservacaoAbertas: {},
        acompanhamentosFormat: this.acompanhamentos ? [...this.acompanhamentos] : [],
        
        dropdownAberto: '',
        ordenacaoAtual: {
          coluna: '',
          ordem: '' 
        }
      };
    },
    watch: {
      acompanhamentos(newVal) {
        if (newVal) {
          this.acompanhamentosFormat = [...newVal];
        } else {
          this.acompanhamentosFormat = [];
        }
      }
    },
    computed: {
      acompanhamentosOrdenados() {
        let lista = [...this.acompanhamentosFormat];        
        
        if (!this.ordenacaoAtual.coluna) {
          return lista.sort((a, b) => {
            // 1. Verifica se já foi assinado
            const assinadoA = !!a.data_da_assinatura;
            const assinadoB = !!b.data_da_assinatura;

            // Se A está assinado e B não, A vai para o final da fila (+1)
            if (assinadoA && !assinadoB) return 1;
            // Se B está assinado e A não, B vai para o final da fila (-1)
            if (!assinadoA && assinadoB) return -1;

            // 2. Se ambos têm o mesmo status (ambos assinados ou ambos não assinados),
            // ordena pela data de "Envio p/ Assinatura" do mais antigo para o mais novo.
            const valA = a.envio_para_assinatura;
            const valB = b.envio_para_assinatura;

            // Joga os que não têm data de envio para o final também
            if (!valA && !valB) return 0;
            if (!valA) return 1;
            if (!valB) return -1;

            const dateA = new Date(valA.includes("T") ? valA : `${valA}T00:00:00`).getTime();
            const dateB = new Date(valB.includes("T") ? valB : `${valB}T00:00:00`).getTime();

            return dateA - dateB; 
          });
        }
      
        const { coluna, ordem } = this.ordenacaoAtual;
        
        return lista.sort((a, b) => {
          const valA = a[coluna];
          const valB = b[coluna];

          if (!valA && !valB) return 0;
          if (!valA) return 1;
          if (!valB) return -1;

          const dateA = new Date(valA.includes("T") ? valA : `${valA}T00:00:00`).getTime();
          const dateB = new Date(valB.includes("T") ? valB : `${valB}T00:00:00`).getTime();

          if (ordem === 'asc') {
            return dateA - dateB; 
          } else {
            return dateB - dateA; 
          }
        });
      },

      classesDeEstilo() {
        if (!this.acompanhamentosOrdenados || this.acompanhamentosOrdenados.length === 0) return [];

        let classes = [];
        let isCinza = true;

        for (let i = 0; i < this.acompanhamentosOrdenados.length; i++) {
          if (i > 0) {
            const itemAtual = this.acompanhamentosOrdenados[i];
            const itemAnterior = this.acompanhamentosOrdenados[i - 1];

            if (itemAtual.processo_sei !== itemAnterior.processo_sei) {
              isCinza = !isCinza;
            }
          }
          classes.push(isCinza ? 'linha-cinza' : '');
        }
        return classes;
      }
    },
    methods: {      
      abrirVisualizacao(acompanhamento) {
        if (!acompanhamento?.id) return;
        this.$router.push({
          name: "AcompanhamentoShow",
          params: { id: acompanhamento.id },
        });
      },
      async aplicarOrdenacao(colunaSelecionada, ordemSelecionada) {
        
        if (this.ordenacaoAtual.coluna === colunaSelecionada && this.ordenacaoAtual.ordem === ordemSelecionada) {
          this.ordenacaoAtual = { coluna: '', ordem: '' };
          this.acompanhamentosFormat = [...this.acompanhamentos];
          this.dropdownAberto = '';
          return;
        }

        this.ordenacaoAtual = { coluna: colunaSelecionada, ordem: ordemSelecionada };
        this.dropdownAberto = '';
        
        try {          
          const filtrosDaUrl = this.$route.query || {};

          let data = await this.acompanhamentoApi.getAcompanhamentos({
            ...filtrosDaUrl,
            qtd_por_pagina: 1000,
            page: 1
          });
                    
          this.acompanhamentosFormat = data.acompanhamentos || data.resultados || [];
        } catch (err) {
          console.error("Erro ao puxar todos os registros para a ordenação:", err);
        }
      },

      toggleObservacao(id) {
        this.$set(this.linhasObservacaoAbertas, id, !this.linhasObservacaoAbertas[id]);
      },
      formatarNomeProprio(texto) {
        if (!texto) return '';
        
        const excecoesMinusculas = ['de', 'da', 'do', 'das', 'dos', 'e'];
                
        const siglasConhecidas = [
          'AGR', 'ALEGO', 'SANEAGO', 'DETRAN', 'SGU', 'SISCOL', 'GOINFRA', 
          'CPF', 'RG', 'GO', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
        ];
        
        return texto
          .toString()
          .toLowerCase()
          .split(' ')
          .map(palavra => {
            const palavraLimpa = palavra.replace(/[()]/g, '').toUpperCase();
  
            if (siglasConhecidas.includes(palavraLimpa)) {
              return palavra.toUpperCase();
            }
  
            if (excecoesMinusculas.includes(palavra)) {
              return palavra;
            }
  
            return palavra.charAt(0).toUpperCase() + palavra.slice(1);
          })
          .join(' ');
      },
      opcoesExcluir(acompanhamentoId) {
        let modalExclusao = document.getElementsByClassName("modal-exclusao");

        for (let i = 0; i < modalExclusao.length; i++) {
          if (modalExclusao[i].id == acompanhamentoId) {
            if (modalExclusao[i].style.visibility !== "visible") {
              modalExclusao[i].style.visibility = "visible";
            } else {
              modalExclusao[i].style.visibility = "hidden";
            }
          }
        }
      },
      exibirConselho(acompanhamento) {
        const indicado = acompanhamento.conselho_indicado_nome;
        const destituido = acompanhamento.conselho_destituido_nome;
                
        if (indicado && indicado.trim() !== '') {
          return indicado;
        }
        
        if (destituido && destituido.trim() !== '') {
          return destituido;
        }
        
        return '-';
      },
      formatarTipoMovimentacao(valor) {
        if (!valor) return '-';
        
        const mapTipos = {
          'indicacao': 'Indicação',
          'destituicao': 'Destituição',
          'substituicao': 'Substituição',
          'exoneracao': 'Exoneração',
          'reconducao': 'Recondução'
        };

        return mapTipos[valor] || valor; 
      },
      formatarCPF(cpf) {
        if (!cpf) return null;
        let cpfLimpo = cpf.toString().replace(/\D/g, '');
        if(cpfLimpo.length === 11) {
          return cpfLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        return cpf;
      },
      async excluirLinha(acompanhamentoId) {
        this.opcoesExcluir(acompanhamentoId);

        try {
          this.carregando = true;
          this.erro = false;

          if (this.acompanhamentoApi.cancelTokens.destroyAcompanhamento) {
            this.acompanhamentoApi.cancelTokens.destroyAcompanhamento.cancel();
          }

          await this.acompanhamentoApi.destroyAcompanhamento(acompanhamentoId);
          window.location.reload(); 
        } catch (err) {
          if (this.acompanhamentoApi.isCancel(err)) {
            return;
          }

          this.carregando = false;
          this.erro = true;

          this.msgErros.acompanhamento =
            "Não foi possível excluir esta movimentação, verifique os vínculos pendentes.";
        }
      },
      formatarData: function (value) {
        if (value == null || value === '') {
          return '-';
        }
        try {
          let fixedValue = value.includes("T") ? value : `${value}T00:00:00`;
          return format(parseISO(fixedValue), "dd/MM/yyyy");
        } catch (e) {
          return value; 
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/TabelaResultadosBase.scss";

/* ========================================================================== */
/* Container da Tabela (Estilo Card Elevado Padrão)                           */
/* ========================================================================== */
/* Como a tabela original não tem a div .tabela-mandatos, estilizamos a div com overflow */
div[style*="overflow-x: auto;"] {
  margin-top: 1.35rem;
  background: #ffffff;
  border: 1px solid #dde5e0;
  border-radius: 0.85rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), 0 10px 28px rgba(0, 0, 0, 0.08);
  /* Scroll é mantido, mas o fundo e a borda abraçam a tabela */
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0;
}

/* ========================================================================== */
/* Estilos de Célula e Cabeçalho (Fonte Karla, Cores SGU)                     */
/* ========================================================================== */
th, td {
  border: none !important;
  border-bottom: 1px solid #e7eee9 !important;
  padding: 0.75rem 0.85rem;
  vertical-align: middle;
  font-size: 0.95rem;
  color: #1f2d24;
  font-family: "Karla", sans-serif;
  background: transparent;
  border-radius: 0 !important;
}

/* Estilização do cabeçalho Padrão SGU */
thead th {
  background: #ededed !important;
  color: #005516 !important;
  font-family: "Karla", sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.25;
  border-bottom: 1px solid #d5e2d9 !important;
  border-right: 1px solid #a6c9b1 !important;
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
  white-space: normal;
}

thead th:last-child {
  border-right: none !important;
}

/* ========================================================================== */
/* Efeito Zebrado e Hover Integrado                                           */
/* ========================================================================== */
tbody tr {
  transition: background-color 0.15s ease;
}

/* Linha Cinza Suave para contrastar */
tbody tr {
  transition: background-color 0.15s ease;
  background-color: #ededed; // Primeira linha (cor padrão que já estava como fundo)
}

/* Segunda linha (linha-cinza) passa a usar exatamente a cor #ededed */
tbody tr.linha-cinza {
  background-color: #ffffff !important;
}

.linha-clicavel {
  cursor: pointer;
}

/* Hover na cor verde institucional (mantendo transparência para o zebrado continuar visível por baixo) */
tbody tr.linha-clicavel:hover {
  background-color: rgba(0, 85, 22, 0.08) !important;
}

.linha-clicavel {
  cursor: pointer;
}

/* Hover na cor verde institucional */
tbody tr.linha-clicavel:hover {
  background-color: rgba(0, 85, 22, 0.05) !important;
}

/* ========================================================================== */
/* Textos Gerais                                                              */
/* ========================================================================== */
.texto-centro {
  text-align: center;
}

.texto-cinza {
  color: #5f6f66;
  font-size: 0.8rem;
  font-family: "Karla", sans-serif;
}

/* ========================================================================== */
/* Filtros nas Colunas (Dropdowns) adaptados ao visual moderno                */
/* ========================================================================== */
.th-filtro {
  position: relative;
  cursor: pointer;
  user-select: none;
}

.header-filtro {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  transition: color 0.2s;
}

.header-filtro:hover {
  color: #008f2b;
}

.setinha {
  font-size: 0.65rem;
  color: #005516;
  display: inline-block;
  transition: transform 0.2s ease;
}

.setinha.aberta {
  transform: rotate(90deg);
}

.caixa-filtro-excel {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #ffffff;
  border: 1px solid #dde5e0;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  border-radius: 0.4rem;
  z-index: 1000;
  min-width: 10rem;
  text-align: left;  
  margin-top: 0.2rem;
}

.caixa-filtro-excel ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.caixa-filtro-excel li {
  padding: 0.6rem 1rem;
  font-size: 0.85rem;
  border-bottom: 1px solid #e7eee9;
  color: #1f2d24;
  font-family: "Karla", sans-serif;
  white-space: nowrap;
}

.caixa-filtro-excel li:last-child {
  border-bottom: none;
}

.caixa-filtro-excel li:hover {
  background-color: #eef6f0;
}

.caixa-filtro-excel li.ativo {
  font-weight: 700;
  background-color: #e6f4ea;
  color: #005516;
}

/* ========================================================================== */
/* Linha de Observação (Expandir / Recolher)                                  */
/* ========================================================================== */
.th-observacao,
.td-observacao {
  width: 3rem !important;
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0 !important;
}

.icone-observacao {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent !important; 
  border: none !important;
  padding: 0.2rem;
}

.icone-observacao span {
  color: #005516 !important;
  font-size: 1.1rem !important;
  display: inline-block;
  line-height: 1;
}

.linha-observacao {
  background-color: #f7faf8 !important;
}

.linha-observacao td {
  text-align: left !important;
  border-top: none !important;
  padding: 0 !important;
}

.conteudo-observacao {
  padding: 0.8rem 1.5rem !important;
  font-size: 0.9rem !important;
  color: #3d4d44 !important;
  border-left: 4px solid #005516; 
  font-family: "Karla", sans-serif;
}

.conteudo-observacao b {
  color: #005516 !important;
  margin-right: 0.4rem !important;
}

/* ========================================================================== */
/* Tabela Vazia (Sem Resultados)                                              */
/* ========================================================================== */
.sem-resultados td {
  text-align: center;
  padding: 2.5rem !important;
}

.sem-resultados p b {
  color: #5f6f66;
  font-family: "Karla", sans-serif;
  font-size: 1rem;
  font-weight: normal;
}

/* ========================================================================== */
/* Larguras das Colunas (Responsividade Tabela)                               */
/* ========================================================================== */
@media screen and (min-width: 1066px) {
  tbody tr td:nth-child(1) { min-width: 7rem; text-align: left; }
  tbody tr td:nth-child(2) { min-width: 10rem; text-align: left; }
  tbody tr td:nth-child(3) { min-width: 10rem; text-align: left; }
  tbody tr td:nth-child(4) { min-width: 10rem; text-align: left; }
  tbody tr td:nth-child(5) { min-width: 10rem; text-align: left; }
  tbody tr td:nth-child(6) { min-width: 10rem; text-align: left; }
  
  tbody tr td:nth-child(7),
  tbody tr td:nth-child(8),
  tbody tr td:nth-child(9),
  tbody tr td:nth-child(10),
  tbody tr td:nth-child(11),
  tbody tr td:nth-child(12) { 
    min-width: 8.2rem; 
    text-align: center; 
  }
}
</style>